import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { LabelScannerPage } from './label-scanner-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [LabelScannerPage],
    imports: [PagesModule, ComponentsModule]
})
export class LabelScannerPageModule { }
